
export class ContractNumberRequest {
    public contractNumber: string;
    public scheduleNumber: number;
    public quoteNo: number;
    public contractType: string;
    public effectiveDate:string;
    public onlinePayFlag: string;
}
